module.exports = __webpack_public_path__ + "img/automation.789f1675.svg";